import Vue from 'vue';
import Router from 'vue-router';
import Binding from '@/components/Binding';
import Fitness from '@/components/Fitness';
import Beian from '@/components/Beian';
import Clubs from '@/components/Clubs';
import Groups from '@/components/Groups';
import Comforts from '@/components/Comforts';
import Holiday from '@/components/Holiday';
import Forbidden from '@/components/Forbidden';
import Uauth from '@/components/Uauth';
import StayTuned from '@/components/StayTuned';
import Admin from '@/components/Admin';
import NuobaoStaff from '@/components/NuobaoStaff';
import EventCalendar from '@/components/EventCalendar';
import Outing from '@/components/Outing';
import Charity from '@/components/Charity';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Beian',
      component: Beian,
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/binding',
      name: 'Binding',
      component: Binding,
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/fitness',
      name: 'Fitness',
      component: Fitness,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/clubss',
      name: 'Clubs',
      component: Clubs,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/groups',
      name: 'Groups',
      component: Groups,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/comforts',
      name: 'Comfort',
      component: Comforts,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/holiday',
      name: 'Holiday',
      component: Holiday,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/stayTuned',
      name: 'StayTuned',
      component: StayTuned,
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/EventCalendar',
      name: 'EventCalendar',
      component: EventCalendar,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/OutingS',
      name: 'Outing',
      component: Outing,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/charity',
      name: 'Charity',
      component: Charity,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/nuobaostaff',
      name: 'NuobaoStaff',
      component: NuobaoStaff,
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/uauth',
      name: 'Uauth',
      component: Uauth,
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta:{
        requireAuth: false
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js